<template>
  <div class="order-list-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch" ></Search>
    <div class="fun-btn-box">
      <auth-button auth="member:point:rule:create">
        <el-button type="primary" class="fun-btn mr10" @click="onAdd" >导出对账记录</el-button>
      </auth-button>
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #storeRefId="{ row }">{{ row.storeRefId }}</template>
      <template #storeName="{ row }">{{ row.storeName }}</template>
      <template #mallName="{ row }">{{ row.mallName }}</template>
      <template #nickname="{ row }">{{ row.nickname ? row.nickname : '---' }}</template>
      <template #phone="{ row, scope }">
        <span :key="tableKey">{{ row.phone_show || row.phone }}</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.phone" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index)">
            {{ row.phone_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #paymentOrderId="{ row }">{{ row.paymentOrderId }}</template>
      <template #amount="{ row }">{{ row.amount }}</template>
      <template #transactionType="{ row }">{{ row.transactionType }}</template>
      <template #payTime="{ row }">{{ row.payTime ? $moment(row.payTime).format('YYYY/MM/DD HH:mm:ss') : '' }}</template>
      <template #refundTime="{ row }">{{ row.refundTime ? $moment(row.refundTime).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #source="{ row }">{{ row.source }}</template>
    </Table>
  </div>
</template>
<script>
import AuthButton from '@/components/AuthButton'
import { api_getFinancePage , api_postFinanceExport} from '@/api/finance'
import tableList from '@/mixins/tableList';
import { downFile } from "@/utils";
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import aes from '@/common/aes.js'
import { api_getUserPhone } from '@/api/common'
export default {
  name: "OIndex",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    return {
      tableKey: false,
      renderData: [
        {
          label: "订单号",
          placeholder: "请输入订单号",
          type: "input",
          key: "paymentOrderId",
        },
        {
          label: "商场名称",
          placeholder: "请选择商场名称",
          type: "mall",
          key: "mallIds",
        },
        {
          label: "会员手机号",
          placeholder: "请输入会员手机号",
          type: "input",
          key: "phone",
          maxLength: 11,
          isNumber: true
        },
        {
          label: "支付时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "created",
        },
        {
          label: "订单来源",
          placeholder: "请选择订单来源",
          type: "select",
          multiple: false,
          key: "source",
          option: [{
            value: 'WechatMiniapp',
            label: '微信小程序'
          },{
            value: 'AlipayMiniapp',
            label: '支付宝小程序'
          }],
        }
      ],
      form: {
        username: "",
        name: "",
      },
      tableThData: [
        { prop: "storeRefId", label: "店铺编号", minWidth: "130", },
        { prop: "storeName", label: "店铺名称", minWidth: "150", },
        { prop: "mallName", label: "商场名称", minWidth: "150", },
        { prop: "nickname", label: "会员姓名", minWidth: "150", },
        { prop: "phone", label: "会员手机号", minWidth: "150", },
        { prop: "paymentOrderId", label: "交易订单号", minWidth: "180", },
        { prop: "amount", label: "订单金额", minWidth: "120", },
        { prop: "transactionType", label: "交易类型", minWidth: "120", },
        { prop: "payTime", label: "支付时间", minWidth: "180", },
        { prop: "refundTime", label: "退款时间", minWidth: "180", },
        { prop: "source", label: "订单来源", minWidth: "180", },
      ]
    };
  },
  created () {
  },
  methods: {
    async onAdd () {
      this.$baseConfirm(
          '是否导出对账记录？',
          {
            title: '提示',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showClose: false,
            type: 'warning',
          },
          async () => {
            let params = {
              ...this.form,
            }
            let res2 = await api_postFinanceExport(params) // 综合统计
            downFile(res2) // 导出综合统计
          }
        )
    },

    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
        isTradeOrder: 1
      }
      this.$router.push({query: params})
      let newParams = {...params}
      if(newParams.created && newParams.created.length > 0){
        newParams.startTime = +new Date(newParams.created[0])
        newParams.endTime = +new Date(newParams.created[1])
      }
      delete newParams.created
      const data = await api_getFinancePage(newParams)
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },
    // 点击查看手机号
    async onLookPhone(row, index) {
      try {
        if (row.phone_show) {
          delete this.tableTrData[index].phone_show
        } else {
          const {phone} = await api_getUserPhone({id: row.userId})
          this.tableTrData[index].phone_show = aes.decrypt(phone)
        }
        this.tableKey = !this.tableKey
      } catch (error) {}
    },
    formatStatus (status) {
      switch (status) {
        case 'DOING':
          return '待付款'
        case 'CANCELED':
          return '已取消'
        case 'FINISHED':
          return '已付款'
        case 'REFUNDED':
          return '已退款'
      }
    }
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.order-list-index {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
  }
  .FINISHED{
    background: #05c8af;
    border-radius: 50%;
    vertical-align: middle;
  }
  .DOING{
    background: #3775FF;
    border-radius: 50%;
    vertical-align: middle;
  }
  .REFUNDED{
    background: #05c8af;
    border-radius: 50%;
    vertical-align: middle;
  }
  .CANCELED{
    background: #F74A4A;
    border-radius: 50%;
    vertical-align: middle;
  }
}
</style>
